import styled from "styled-components"
import { NeutralRawLink } from "../../../ui/components/link/link.component"

export const Item = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
`

export const Bar = styled.div<{
  level: number
  $isCategory?: boolean
  $active?: boolean
}>`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: ${({ $isCategory, $active }) =>
    $isCategory && $active ? null : "1px solid #e5e5e5"};
  margin-left: ${({ level }) =>
    level === 2 ? "30px" : level === 3 ? "45px" : null};
`

export const Category = styled.div<{ $active?: boolean }>`
  font-family: ${({ theme }) => theme.font.display};
  font-size: 12px;
  margin: 15px 0;
  margin-bottom: ${({ $active }) => $active && "0px"};
  padding: 0;
  text-transform: uppercase;
  color: #737373;
  font-weight: 500;
  line-height: 2;
  letter-spacing: 2px;
`

export const Path = styled(NeutralRawLink)<{
  level: number
  $active?: boolean
  $isCategory?: boolean
}>`
  font-family: ${({ theme }) => theme.font.display};
  margin: 15px 0;
  padding-left: 15px;
  font-weight: 500;
  text-transform: ${({ level }) => level === 1 && "uppercase"};
  line-height: 2;
  letter-spacing: 2px;
  color: ${({ $active, theme, $isCategory }) =>
    $active && !$isCategory ? theme.color.link : theme.color.text};

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile - 1}px) {
    max-width: 270px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.mobile}px) {
    padding-right: 30px;
  }
`

export const ArrowWrapper = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 25px;

  svg {
    transition: transform 0.5s;
    height: 16px;
    width: 16px;
  }
`

export const SubItems = styled.ul<{ $active?: boolean }>`
  transition: all 0.3s ease-in-out;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  visibility: ${({ $active }) => ($active ? "visible" : "hidden")};
  max-height: ${({ $active }) => ($active ? "1000px" : 0)};

  font-size: ${14 / 16}rem;
  line-height: ${30 / 14}em;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    font-size: ${16 / 16}rem;
    line-height: ${32 / 16}em;
  }
`
